import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import Table from "components/Table";
import Columns from "./Columns";
import { getExportRequestList } from "store/settings/actions";
import usePermission from "hooks/usePermission";
import FormikForm from "components/shared/FormikForm";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search by Job ID...",
  },
  {
    name: "status",
    type: "select",
    label: "",
    placeholder: "Select Status...",
    options: [
      { label: "All", value: "" },
      { label: "Available", value: "available" },
      { label: "Processing", value: "processing" },
      { label: "Failed", value: "failed" },
      { label: "Ready", value: "ready" },
    ],
  },
  {
    name: "format",
    type: "select",
    label: "",
    placeholder: "Select Format...",
    options: [
      { label: "All", value: "" },
      { label: "csv", value: "csv" },
      { label: "xlsx", value: "xlsx" },
    ],
  },
  {
    name: "type",
    type: "select",
    label: "",
    placeholder: "Select Type...",
    options: [
      { label: "All", value: "" },
      { label: "Leaderboard", value: "leaderboard" },
      { label: "Game History", value: "gamehistory" },
      { label: "User", value: "users" },
      { label: "Jackpot", value: "jackpot" },
    ],
  },
];

const initialValuesForFilter = {
  search: "",
  status: "",
  format: "",
  type: "",
};

const ExportRequest = () => {
  const dispatch = useDispatch();

  const { exportRequestList, exportRequestLoading, exportRequestCount } =
    useSelector(({ Settings }) => Settings);

  const { hasPermission } = usePermission();
  const permissions = hasPermission("view_export_request");

  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
    format: "",
    type: "",
  });

  // Fetch data
  useEffect(() => {
    dispatch(getExportRequestList({ data: filter }));
  }, [filter]);

  // Setup columns
  useEffect(() => {
    setColumns(
      Columns().filter((item) => {
        if (item?.text === "Action" && !permissions.edit) {
          return false;
        }
        return true;
      }),
    );
  }, [permissions]);

  const handleFilterForm = (values) => {
    setFilter({
      ...filter,
      page: 1,
      search: values.search,
      status: values.status,
      format: values.format,
      type: values.type,
    });
  };

  return (
    <>
      <Helmet title="Export Requests" />

      <section className="section">
        <div className="section-header">
          <h1>Export Requests</h1>
        </div>

        <div className="section-body">
          <div className="card">
            <div className="row">
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={exportRequestLoading}
                    inputFields={InputFieldsForSearch}
                    buttonText="Search"
                  />
                </div>
              </div>
            </div>
          </div>

          {exportRequestLoading && (
            <div className="main-loader">
              <FadeLoader size={1000} />
            </div>
          )}

          {!exportRequestLoading && exportRequestList?.length > 0 && (
            <Table
              data={exportRequestList}
              columns={columns}
              setFilter={setFilter}
              total={exportRequestCount}
              filter={filter}
              // handleView={handleView}
            />
          )}

          {!exportRequestLoading && exportRequestList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Export Requests Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default ExportRequest;
